import { NumeroEtapaFinal } from "../config/enums/enums";
import { iDataProyectoDynamoDB, iDataProyectoDynamoDBOrganizacion } from "../interfaces/iDataProyectoDynamoDB";
import { iDataProyectosResultadoMap } from "../interfaces/UmmiaApps/iDataProyectosResultadoMap";


export const descubrirProyectosConResultados = (nodos: iDataProyectoDynamoDB[] | iDataProyectoDynamoDBOrganizacion[]): Array<iDataProyectosResultadoMap> => {
  return nodos.flatMap((nodo: any) => {
    // Filtrar resultados según la etapa final
    const resultadosFiltrados = identificarYFiltrarResultados(nodo);

    if(resultadosFiltrados.length === 0) return [];

    // Formatear los resultados filtrados
    return formatearResultados(nodo, resultadosFiltrados);
  });
};


// Función para identificar la etapa final y evaluar los resultados
export const identificarYFiltrarResultados = (nodo: iDataProyectoDynamoDB | iDataProyectoDynamoDBOrganizacion): any[] => {
  const { resultados, tipoEstructura } = nodo;

  // Identificar la etapa final según el tipo de estructura
  const etapaFinal = NumeroEtapaFinal[tipoEstructura as keyof typeof NumeroEtapaFinal] ?? 0;

  // Filtrar los resultados que tengan la etapa válida
  const resultadosValidos = resultados.items.filter((r: any) => r.etapa === etapaFinal)
    .sort(
      (a: any, b: any) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

  return resultadosValidos;
};

// Función para formatear los datos
export const formatearResultados = (nodo: iDataProyectoDynamoDB | iDataProyectoDynamoDBOrganizacion, resultadosFiltrados: any[]): Array<iDataProyectosResultadoMap> => {
  if (resultadosFiltrados.length === 0) return [];

  const { name, tipoEstructura, nivelCurso, createdAt, usuarioId } = nodo;
  const usuario = 'usuario' in nodo ? nodo.usuario : undefined;

  const resultadoMasReciente = resultadosFiltrados[0];
  const { resultado, id, etapa, calificacion } = resultadoMasReciente;
  const objetoFinalResultado = JSON.parse(resultado);
  const propuestas = objetoFinalResultado.propuestas || resultado;
  const titulo = propuestas?.Titulo || name;

  // Objeto base que se devolverá
  const baseResult = {
    proyectoId: nodo.id,
    titulo,
    resultadoPropuestaId: id,
    propuesta: propuestas,
    tipoEstructura,
    nivel: nivelCurso,
    fechaCreacion: createdAt,
    calificacion,
    etapa,
    usuarioId,
    isEliminated: false,
  };

  // Si el nodo tiene propiedad usuario, se agrega al resultado
  if (usuario) {
    return [{ ...baseResult, usuario }];
  }
  return [baseResult];
};



// export const descubrirProyectosConResultados = (nodos: iDataProyectoDynamoDB[] | iDataProyectoDynamoDBOrganizacion[]): Array<iDataProyectosResultadoMap | iDataProyectosResultadoMap> => {
//   return nodos.flatMap((n: any) => {
//     const { resultados, name, tipoEstructura, nivelCurso, createdAt } = n;

//     // Determinar la etapa final válida según el tipo de estructura
//     const etapaFinal =
//       NumeroEtapaFinal[tipoEstructura as keyof typeof NumeroEtapaFinal] ?? 0;

//     // Filtrar los resultados que tengan la etapa válida y ordenarlos por fecha descendente
//     const resultadosValidos = resultados.items
//       .filter((r: any) => r.etapa === etapaFinal)
//       .sort(
//         (a: any, b: any) =>
//           new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
//       );

//     if (resultadosValidos.length === 0) return [];

//     const resultadoMasReciente = resultadosValidos[0];
//     const { resultado, id, etapa, calificacion } = resultadoMasReciente;
//     const objetoFinalResultado = JSON.parse(resultado);
//     const propuestas = objetoFinalResultado.propuestas || resultado;
//     const titulo = propuestas?.Titulo || name;

//     // Objeto base que se devolverá
//     const baseResult = {
//       proyectoId: n.id,
//       titulo,
//       resultadoPropuestaId: id,
//       propuesta: propuestas,
//       tipoEstructura,
//       nivel: nivelCurso,
//       fechaCreacion: createdAt,
//       calificacion,
//       etapa,
//     };

//     // Si el nodo tiene propiedad usuario, se agrega al resultado
//     if (n.usuario) {
//       return [{ ...baseResult, usuario: n.usuario }];
//     }
//     return [baseResult];
//   });
// };